module.exports = __webpack_public_path__ + "assets/img/1418.14c6558e.png";